import React from 'react';
import { Responsive, useContainerWidth, getCompactor } from 'react-grid-layout';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import DraggableChartWidget from './DraggableChartWidget';

import '../scss/workspace-view.scss';

interface ActiveWidget {
  id: string;
  sidebarId: string;
  type: string;
  data: any;
  heading: string;
  x: number; // Grid column (0-11)
  y: number; // Grid row (0+)
  w: number; // Grid width (1-12)
  h: number; // Grid height (1-10+)
}

interface WorkspaceViewProperties {
  filters: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  };
  selectedDashboard: any;
  startDate?: string;
  endDate?: string;
}

/**
 * WorkspaceView component
 * Renders the saved custom widgets in a read-only or draggable workspace
 * @param {any} param0 - The param0
 * @param {any} param0.filters - The filters prop
 * @param {any} param0.selectedDashboard - The selectedDashboard prop
 * @param {any} param0.startDate - The startDate prop
 * @param {any} param0.endDate - The endDate prop
 */
function WorkspaceView({
  filters,
  selectedDashboard,
  startDate,
  endDate,
}: WorkspaceViewProperties) {
  const { containerRef, width } = (useContainerWidth as any)();

  const layout = selectedDashboard?.widgets?.map((w: ActiveWidget) => ({
    i: w.id,
    x: w.x,
    y: w.y,
    w: w.w,
    h: w.h,
    static: true, // Read-only view
  }));

  return (
    <div className="workspace-view-wrap">
      <div className="workspace-area" ref={containerRef}>
        {selectedDashboard?.widgets?.length > 0 ? (
          <Responsive
            className="layout"
            layouts={{ lg: layout, md: layout, sm: layout, xs: layout, xxs: layout }}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
            rowHeight={80}
            width={width}
            margin={[16, 16]}
            dragConfig={{ enabled: false }}
            resizeConfig={{ enabled: false }}
            compactor={getCompactor(null, false, true)}>
            {selectedDashboard?.widgets?.map((widget: any) => (
              <div key={widget.id}>
                <DraggableChartWidget
                  id={widget.id}
                  type={widget.type}
                  style={{
                    cursor: 'default',
                  }}
                  data={widget.data}
                  heading={widget.heading}
                  filters={filters}
                  startDate={startDate}
                  endDate={endDate}
                  viewonly
                />
              </div>
            ))}
          </Responsive>
        ) : (
          <div className="no-widgets-message">
            <h3>No custom widgets added yet</h3>
            <p>Go to &quot;Customize Dashboard&quot; to create your perfect layout.</p>
          </div>
        )}
      </div>
    </div>
  );
}
WorkspaceView.defaultProps = {
  startDate: '',
  endDate: '',
};
export default WorkspaceView;
